<div #divWrapper [ngClass]="wrapperClasses">
    <div *ngIf="gotTags">
        <mat-expansion-panel hideToggle>
            <mat-expansion-panel-header>
                <mat-panel-title>Available Tags (Click to view then drag and drop into the body below)</mat-panel-title>
            </mat-expansion-panel-header>
            <div class="draggable" *ngFor="let tag of tags" draggable="true" [innerHTML]="tag.key" (dragstart)="dragstart($event, tag)"></div>
        </mat-expansion-panel>
    </div>
    <mat-label *ngIf="!input.hideLabel" (click)="focus()" [ngClass]="{'required': input.required}">{{input.label}}</mat-label>
    <ckeditor
        #editorComponent
        [ngClass]="'ucr-rich-text'"
        (dragover)="over($event)"
        [id]="input.property"
        [editor]="editor"
        [data]="initialData"
        (change)="editorChange($event)"
        (blur)="editorBlur($event)"
    ></ckeditor>
    <mat-error class="text-error">{{errorMessage}}</mat-error>
    <mat-hint [ngClass]="hint?.class">{{hint?.message}}</mat-hint>
</div>